import z from "zod";
// ------------ PROTOCOL TYPES START --------------
export const ZMsgKind = z.enum([
    "HandshakeInit",
    "HandshakeComplete",
    "Ping",
    "Pong",
    "ConnectionClosed",
    "Common",
    "Request",
    "Response",
]);
export const ZICRC35Base = z.object({
    domain: z.literal("icrc-35"),
});
export const ZHandshakeInitMsg = ZICRC35Base.extend({
    kind: z.literal(ZMsgKind.Enum.HandshakeInit),
}).strict();
export const ZHandshakeCompleteMsg = ZICRC35Base.extend({
    kind: z.literal(ZMsgKind.Enum.HandshakeComplete),
}).strict();
export const ZPingMsg = ZICRC35Base.extend({
    kind: z.literal(ZMsgKind.Enum.Ping),
}).strict();
export const ZPongMsg = ZICRC35Base.extend({
    kind: z.literal(ZMsgKind.Enum.Pong),
}).strict();
export const ZConnectionClosedMsg = ZICRC35Base.extend({
    kind: z.literal(ZMsgKind.Enum.ConnectionClosed),
}).strict();
export const ZCommonMsg = ZICRC35Base.extend({
    kind: z.literal(ZMsgKind.Enum.Common),
    payload: z.any(),
});
export const ZRequestId = z.string().uuid();
export const ZRoute = z.string().url();
export const ZRequestMsg = ZICRC35Base.extend({
    kind: z.literal(ZMsgKind.Enum.Request),
    requestId: ZRequestId,
    route: ZRoute,
    payload: z.any(),
});
export const ZResponseMsg = ZICRC35Base.extend({
    kind: z.literal(ZMsgKind.Enum.Response),
    requestId: ZRequestId,
    payload: z.any(),
});
export const ZMsg = z.discriminatedUnion("kind", [
    ZHandshakeInitMsg,
    ZHandshakeCompleteMsg,
    ZPingMsg,
    ZPongMsg,
    ZConnectionClosedMsg,
    ZCommonMsg,
    ZRequestMsg,
    ZResponseMsg,
]);
// ------------ PROTOCOL TYPES END --------------
// ------------- ADDITIONAL TYPES START --------------
export const ZOrigin = z.string().url();
export const ZPeer = z.custom((val) => {
    const res = typeof val === "object" && "postMessage" in val && typeof val.postMessage === "function";
    return res;
});
export const ZListener = z.custom((val) => {
    const res = typeof val === "object" &&
        "addEventListener" in val &&
        "removeEventListener" in val &&
        "origin" in val &&
        typeof val.addEventListener === "function" &&
        typeof val.removeEventListener === "function" &&
        typeof val.origin === "string";
    return res;
});
export const ZConnectionFilter = z
    .object({
    kind: z.enum(["blacklist", "whitelist"]),
    list: z.array(ZOrigin),
})
    .strict();
export const ZEndpointParentMode = z.object({
    mode: z.literal("parent"),
    peerOrigin: ZOrigin,
});
export const ZEndpointChildMode = z.object({
    mode: z.literal("child"),
    connectionFilter: z.optional(ZConnectionFilter),
});
export const ZEndpointMode = z.discriminatedUnion("mode", [ZEndpointParentMode, ZEndpointChildMode]);
export const ZEndpointModeKind = z.enum(["parent", "child"]);
export const ZICRC35ConnectionConfig = z.object({
    peer: ZPeer,
    listener: z.optional(ZListener),
    mode: ZEndpointModeKind,
    peerOrigin: z.optional(ZOrigin),
    connectionFilter: z.optional(ZConnectionFilter),
    debug: z.optional(z.boolean()),
});
/**
 * Request object that simplifies decoupling of components.
 */
export class ICRC35AsyncRequest {
    connection;
    inProgress;
    requestId;
    peerOrigin;
    route;
    payload;
    constructor(init) {
        this.connection = init.connection;
        this.inProgress = true;
        this.requestId = init.requestId;
        this.peerOrigin = init.peerOrigin;
        this.route = init.route;
        this.payload = init.payload;
    }
    respond(response, transfer) {
        if (!this.inProgress)
            return;
        this.inProgress = false;
        this.connection.respond(this.requestId, response, transfer);
    }
    closeConnection() {
        this.connection.close();
    }
}
// ------------- ADDITIONAL TYPES END --------------
